export default __webpack_public_path__ + "static/media/servicesbg.6b21bf4a.jpg";